import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["onChange", "onSelect", "value"];
import React, { memo, useEffect, useState } from 'react';
export var withState = function withState(WrappedComponent) {
  return /*#__PURE__*/memo(function (_ref) {
    var onChange = _ref.onChange,
      onSelect = _ref.onSelect,
      value = _ref.value,
      props = _objectWithoutProperties(_ref, _excluded);
    var _useState = useState(value || ''),
      _useState2 = _slicedToArray(_useState, 2),
      stateValue = _useState2[0],
      setStateValue = _useState2[1];
    var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      options = _useState4[0],
      setOptions = _useState4[1];
    var _useState5 = useState(undefined),
      _useState6 = _slicedToArray(_useState5, 2),
      activeOption = _useState6[0],
      setActiveOption = _useState6[1];
    var handleChange = function handleChange(val) {
      setStateValue(val);
      setActiveOption(undefined);
      onChange === null || onChange === void 0 ? void 0 : onChange(val);
    };
    useEffect(function () {
      if (value !== undefined) {
        setStateValue(value);
      }
    }, [value]);
    var handleSelect = function handleSelect(option) {
      setActiveOption(option);
      onSelect === null || onSelect === void 0 ? void 0 : onSelect(option);
    };
    return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, {
      activeOption: activeOption,
      onChange: handleChange,
      onChangeOptions: setOptions,
      onSelect: handleSelect,
      options: options,
      value: stateValue,
      "data-t-id": "inputs-SearchInput"
    }));
  });
};